import proj4 from 'proj4'
import { projections } from 'src/lib/projections'
proj4.defs(projections)

export function fileToText (file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onerror = reject
    fileReader.onabort = reject
    fileReader.onload = evt => resolve(evt.target.result)
    fileReader.readAsText(file)
  })
}

export async function jsonFileToObject (file) {
  const text = await fileToText(file)
  return JSON.parse(text)
}

function xmlToJson (xml) {
  // Create the return object
  var obj = {}
  if (xml.nodeType === 1) { // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {}
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j)
        obj['@attributes'][attribute.nodeName.replace('cp:', '').replace('gml:', '')] = attribute.nodeValue
      }
    }
  } else if (xml.nodeType === 3) { // text
    obj = xml.nodeValue
  }

  // do children
  if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i)
      var nodeName = item.nodeName.replace('cp:', '').replace('gml:', '')
      if (typeof obj[nodeName] === 'undefined') {
        obj[nodeName] = xmlToJson(item)
      } else {
        if (typeof obj[nodeName].push === 'undefined') {
          var old = obj[nodeName]
          obj[nodeName] = []
          obj[nodeName].push(old)
        }
        obj[nodeName].push(xmlToJson(item))
      }
    }
  }
  return obj
}

function polygonGeoJSONFormat (coordinates, area, refcad, epsg) {
  return {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates
      },
      properties: {
        area,
        refcad
      },
      crs: {
        type: 'name',
        properties: {
          name: `urn:ogc:def:crs:EPSG::${epsg}`
        }
      }
    }]
  }
}

function extractCoordinates (ring, epsg) {
  const dimensionRing = ring['@attributes'] && ring['@attributes']['srsDimension']
  const textRing = ring['#text'].split(' ')

  let coordsRing = []
  for (let i = 0; i < textRing.length; i += parseInt(dimensionRing)) {
    const coordsProj = proj4(`EPSG:${epsg}`, 'EPSG:4326').forward([
      parseFloat(textRing[i]), parseFloat(textRing[i + 1])
    ])
    coordsRing.push(coordsProj)
  }
  return coordsRing
}

function getPolygon (surfaceMember, epsg) {
  const surface = surfaceMember['Surface']
  const PolygonPatch = surface['patches'] && surface['patches']['PolygonPatch']
  if (!PolygonPatch) {
    return null
  }
  let polygon = []
  const exteriorRing = PolygonPatch['exterior'] && PolygonPatch['exterior']['LinearRing'] && PolygonPatch['exterior']['LinearRing']['posList']
  polygon.push(extractCoordinates(exteriorRing, epsg))

  let interiorPatch = PolygonPatch['interior']
  if (!interiorPatch) {
    return polygon
  }
  if (!Array.isArray(interiorPatch)) {
    interiorPatch = [interiorPatch]
  }
  interiorPatch.forEach(patch => {
    const interiorRing = patch['LinearRing'] && patch['LinearRing']['posList']
    polygon.push(extractCoordinates(interiorRing, epsg))
  })
  return polygon
}

export async function gmlFileToObject (file) {
  const text = await fileToText(file)
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(text, 'text/xml')
  const json = xmlToJson(xmlDoc)
  const member = json && json['FeatureCollection'] && (json['FeatureCollection']['member'] || json['FeatureCollection']['featureMember'])
  const cadastralParcel = member && member['CadastralParcel']
  if (!cadastralParcel) {
    return null
  }
  let surfaceMember = (
    cadastralParcel['geometry'] && cadastralParcel['geometry']['MultiSurface'] &&
    cadastralParcel['geometry']['MultiSurface']['surfaceMember']
  )
  if (!Array.isArray(surfaceMember)) {
    surfaceMember = [surfaceMember]
  }
  let epsg = (
    surfaceMember[0]['Surface']['@attributes'] && surfaceMember[0]['Surface']['@attributes']['srsName'] &&
    surfaceMember[0]['Surface']['@attributes']['srsName'].split('/')
  )
  epsg = epsg.length > 1 ? epsg : epsg[0].split(':')
  epsg = epsg[epsg.length - 1]
  const coordinates = surfaceMember.map(surfaceMember => getPolygon(surfaceMember, epsg))
  const area = cadastralParcel['areaValue'] && (cadastralParcel['areaValue']['#text'] + ' ' + cadastralParcel['areaValue']['@attributes']['uom'])
  const refcad = cadastralParcel['nationalCadastralReference'] && cadastralParcel['nationalCadastralReference']['#text']
  return polygonGeoJSONFormat(coordinates, area, refcad, epsg)
}
